/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-10-31 16:30:23
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-10-31 17:00:50
 */
import request from '@/utils/request'

// 消息已读 -新
export async function messageRead(params?: any) {
  return request('/api/v2/interact/message_read', {
    method: 'POST',
    data: params
  })
}

// 消息列表 -新
export async function getMessageList(params?: any) {
  return request('/api/v2/interact/message_list', {
    method: 'GET',
    data: params
  })
}

// 消息读取 -新
export async function messageCount(params?: any) {
  return request('/api/v2/interact/message_count', {
    method: 'GET',
    data: params
  })
}

// 审核加入小组
export async function auditJion(params?: any) {
  return request('/api/v2/interact/topic/audit_join', {
    method: 'POST',
    data: params
  })
}
